import { type PortableTextComponentProps } from '@portabletext/react'
import {
  type PortableTextListItemBlock,
  type PortableTextMarkDefinition,
  type PortableTextSpan,
} from '@portabletext/types'

import { colors } from '@lib/theme'

import CheckmarkCircleIcon from '@components/icons/checkmark-circle'

type CheckmarkListItemProps = PortableTextComponentProps<
  PortableTextListItemBlock<
    PortableTextMarkDefinition,
    PortableTextSpan,
    string,
    string
  >
>

const CheckmarkListItem = ({ children }: CheckmarkListItemProps) => {
  return (
    <li>
      <CheckmarkCircleIcon
        color={colors.green.dark}
        backgroundColor={colors.yellow.DEFAULT}
      />
      {children}
    </li>
  )
}

export default CheckmarkListItem
